import {styleRule, UI, StyleSheet} from "../../../../stem-core/src/ui/UI";

import {registerStyle} from "../../../../stem-core/src/ui/style/Theme";
import {Dispatcher} from "../../../../stem-core/src/base/Dispatcher";
import {autoredraw} from "../../../../stem-core/src/decorators/AutoRedraw.js";
import {IndexCollapsed} from "../index-collapsed/IndexCollapsed.jsx";
import {WidgetActiveRouteElement} from "../../ui/WidgetActiveRouteElement.jsx";
import {isSmallScreen} from "../../../UtilsLib.js";
import {WALLET_EXPANDED_WIDTH} from "../../WidgetConstants.js";
import {authService} from "../../../../client/connection/services/AuthService.js";
import {iFrameUserDataService} from "../../../services/IFrameUserDataService.js";
import {IndexHome} from "./sections/IndexHome.jsx";
import {AddFunds} from "../add-funds/AddFunds.jsx";
import {isFirefox, isSafari} from "../../../../stem-core/src/base/Utils.js";


class IndexExpandedStyle extends StyleSheet {
    @styleRule
    container = {
        cursor: "initial",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        width: "100%",
        position: "relative",
        paddingBottom: 39,
        overflow: "hidden",
        borderRadius: isSmallScreen() ? 0 : "12px 12px 0 0",
    };

    @styleRule
    innerContainer = {
        position: "relative",
        overflow: "hidden",
        background: this.themeProps.WHITE,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        flex: 1,
        justifyContent: "flex-end",
    };

    @styleRule
    hidden = {
        opacity: 0,
        // These are for Safari border bugs during animations.
        "-webkit-backface-visibility": "hidden",
        "-moz-backface-visibility": "hidden",
        "-webkit-transform": "translate3d(0, 0, 0)",
        "-moz-transform": "translate3d(0, 0, 0)",
    };

    @styleRule
    homePageContainer = {
        height: isSafari() ? "100%" : "fit-content", // TODO @theme why isSafari?
        minWidth: WALLET_EXPANDED_WIDTH,
        maxHeight: isFirefox() ? "initial !important" : "",
        paddingTop: "12px !important",
    };

    @styleRule
    walletSection = {
        width: "100%",
        position: "absolute",
        zIndex: 3,
        minWidth: 360,
    };
}

// TODO Rethink how this works with donations.
@autoredraw(iFrameUserDataService)
@registerStyle(IndexExpandedStyle)
export class IndexExpanded extends WidgetActiveRouteElement {
    hiddenHomeSection = true;

    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        // This is to fix the bad color transition when closing a modal
        if (!authService.isAuthenticated()) {
            attr.setStyle("opacity", 0);
        }
    }

    render() {
        const {styleSheet} = this;
        const includeAddFunds = !(this.hiddenHomeSection || !authService.isAuthenticated())
        const homeSectionStyle = (this.hiddenHomeSection ? styleSheet.hidden : "");

        return [
            <div ref="innerContainer" className={styleSheet.innerContainer + homeSectionStyle}>
                <IndexHome ref="nav" className={styleSheet.homePageContainer}/>
            </div>,

            includeAddFunds && <AddFunds ref="widgetAddFunds" className={styleSheet.walletSection + homeSectionStyle} />,

            <IndexCollapsed/>,
        ];
    }

    static show(options) {
        Dispatcher.Global.dispatch("preventCardScrollDisplay");
        this.instance.hiddenHomeSection = false;
        this.instance.updateOptions(options);
    }

    static hide() {
        this.instance.hiddenHomeSection = true;
        this.instance.redraw();
    }

    computeHeight() {
        return this.nav.computeHeight();
    }
}
